'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./section-handler-widget');

mmWidgets.fn.goldSessionsSidebarWidget = function ({goldSessionModel, navigatorShim}) {
	if (!goldSessionModel || !navigatorShim) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget(),
			template = widget.find('[data-mm-role~="template"]'),
			templateContainer = template.parent(),
			sessionAdded = (session) => {
				const sessionElement = template.clone().appendTo(templateContainer);
				sessionElement.attr({
					'data-mm-role': 'session',
					'data-session-id': session.sessionId
				});
				sessionElement.find('[data-mm-role="description"]').text(session.description).attr({'data-mm-tooltip': session.description});
				sessionElement.find('[data-mm-role="session-color"]').css({backgroundColor: session.color});
				widget.showSection('active');
			},
			sessionRemoved = (session) => {
				const sessionElement = widget.find(`[data-mm-role~=session][data-session-id="${session.sessionId}"]`);
				sessionElement.remove();
				if (widget.find('[data-mm-role~=session]').length === 0) {
					widget.showSection('alone');
				} else {
					widget.showSection('active');
				}
			},
			sessionError = () => {
				widget.showSection('blocked');
			};
		template.remove();
		goldSessionModel.addEventListener('sessionAdded', sessionAdded);
		goldSessionModel.addEventListener('sessionRemoved', sessionRemoved);
		goldSessionModel.addEventListener('sessionError', sessionError);
		navigatorShim.addEventListener('network-status', isOnline => {
			if (!isOnline) {
				widget.showSection('offline');
			}
		});
		widget.showSection('alone');
	});
};

